import { SBModel } from './SBmodel'

export interface Form extends SBModel {
  name: string

  //   Relations   \\
  pages: FormPage[]
}

export interface FormItem extends SBModel {
  question: string
  description?: string
  order?: number
  required?: boolean
  isCommentableByManager: boolean
  isAnswerableByManager: boolean

  //   Relations   \\
  type: FormItemType
  options?: FormItemOption[]
  associatedAnswers?: AssociatedAnswer[]
  employeeAnswer?: string
  managerAnswer?: string
}

export interface FormItemOption extends SBModel {
  name: string
  value?: string
  order: number
}

export interface FormItemType extends SBModel {
  name: string
  icon: string
  optionable: boolean
  requirable: boolean
}

export interface FormPage extends SBModel {
  name: string
  order: number

  //   Relations   \\
  items: FormItem[]
}

export interface AssociatedAnswer {
  campaign: string
  answer: string
  item: FormItem
  options: FormItemOption[]
}

export enum FormItemTypes {
  Title = 1,
  Input,
  TextArea,
  CheckboxGroup,
  Select,
  Rate,
  Spacer,
}

export const isFillable = (item: FormItem): boolean =>
  [2, 3, 4, 5, 6].includes(item.type.id)
